import { Observable, interval } from 'rxjs'
import { map, mergeMap, pluck } from 'rxjs/operators'
import { ofType, StateObservable } from 'redux-observable'
import { startQualityCheck } from '../../actions/tracks/trackActions'
import { ReduxAction, State } from '../../reducers/reducerType'
import { Enum } from '@bt-react/store'
import { afterAllTypes } from '../../../lib/observables'
import { getQualityScore } from '@bt-react/libs/getQualityScore'


const systemCheck$ = (actions$: Observable<ReduxAction>, state$: StateObservable<State>) => actions$.pipe(
  ofType(Enum.UserServiceType.FETCH_USER_DATA_SUCCESS),
  mergeMap(() => [startQualityCheck()]
  )
)

const systemCheckReport$ = (actions$, state$: StateObservable<State>) => actions$.pipe(
    afterAllTypes('QUALITY_CHECK_NETWORK_DONE', 'QUALITY_CHECK_BANDWIDTH_DONE'),
    map((value, i) => {
        /*@ts-ignore*/
        const score = getQualityScore(value.find(action => action.type === 'QUALITY_CHECK_NETWORK_DONE').payload, value.find(action => action.type === 'QUALITY_CHECK_BANDWIDTH_DONE').payload)
        return {type: 'QUALITY_CHECK_DONE', payload: score}
    }
    )
  )

 export { systemCheck$, systemCheckReport$ }
